module.exports = __webpack_public_path__ + "ci_vendor_aws.dc2c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_aws.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_aws.svg
// module chunks = main